
const CustomLoadingOverlay = () => (
  <div className="ag-custom-loading-overlay" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
    <span className="ag-overlay-loading-center">Please wait while your rows are loading...  <i className="fa fa-spinner fa-spin"></i></span>
  </div>
);

export default CustomLoadingOverlay;
